import { render, staticRenderFns } from "./SanitizeHTML.vue?vue&type=template&id=f0101c2c"
import script from "./SanitizeHTML.vue?vue&type=script&lang=ts"
export * from "./SanitizeHTML.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports